// extracted by mini-css-extract-plugin
export default {"innerWrapper":"nr-z","tooltipWrapper":"or-z","icon":"pr-z","tooltip":"qr-z","content":"rr-z"};